/*
 * rheincool — Artikel-Store (HANDOFF.md §8.3 State-Durchreichung)
 * Mini-Pub/Sub pro Seite: Rechner publizieren Ergebnisse, Abschluss-Sektionen
 * und Tabellen-Hervorhebungen abonnieren. Werte überleben den Seitenwechsel
 * nicht (bewusst — Artikel sind in sich geschlossen).
 *
 * API:
 *   window.rcStore.set('kw', { kw: 3.5, count: 12 })
 *   window.rcStore.get('kw')            → letzter Wert oder undefined
 *   window.rcStore.subscribe('kw', fn)  → fn(wert) sofort (falls vorhanden) + bei Updates
 */
(() => {
  'use strict';
  if (window.rcStore) return;

  const values = new Map();
  const listeners = new Map();

  window.rcStore = {
    set(key, value) {
      values.set(key, value);
      (listeners.get(key) || []).forEach((fn) => {
        try {
          fn(value);
        } catch (error) {
          console.warn('[rc-store]', error);
        }
      });
    },
    get(key) {
      return values.get(key);
    },
    subscribe(key, fn) {
      if (!listeners.has(key)) listeners.set(key, []);
      listeners.get(key).push(fn);
      if (values.has(key)) fn(values.get(key));
    },
  };
})();
